const colors = {
  white: 'hsl(0, 0%, 100%)',
  grayishBlue: 'hsl(240, 2%, 79%)',
  veryDarkGrayishBlue: 'hsl(207, 13%, 34%)',
  veryDarkBlackBlue: 'hsl(240, 10%, 16%)',
  lightRed: 'hsl(356, 100%, 66%)',
  veryLightRed: 'hsl(355, 100%, 74%)',
  veryDarkBlue: 'hsl(208, 49%, 24%)',
}

export default colors